<div class="column">
    <h2>Malattia di Crohn - Pazienti stabili e instabili per precedenti chirurgici</h2>
    <div style="display: inline-block" style = "padding-left: 3vw; padding-top: 0vw; position: center">
      <div class = "chart-container" [ngStyle]="{'cursor': isHovered ? 'pointer' : ''}">
        <canvas id = "myChartStableUnstableCrohnPreviousSurgery"></canvas>
      </div>
    </div>
  </div>